<template>
  <div>
    <div class="p-lg">
      <h1>Progress Steppers</h1>
      <hr />
    </div>
    <h2 class="text-center">Simple Progress Stepper Bar</h2>
    <BarProgressStepper
      :current-step="currentStepIndex + 1"
      :total-steps="steps.length"
      start-label="Start"
      end-label="Complete"
    />
    <h2 class="text-center mt-xl">Informative Progress Stepper with titled, clickable steps</h2>
    <TitledProgressStepper
      :steps="steps"
      @goToStep="goToStep"
    />
    <div class="flex items-center justify-center mt-xl">
      <BaseButton
        @click.native="goToStep(currentStepIndex + 1)"
      >
        Complete Current Step
      </BaseButton>
    </div>
    <div
      v-if="currentStepIndex === 0"
      class="p-xl"
    >
      <h2>Step 1 Content</h2>
      <p>of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
    </div>
    <div
      v-if="currentStepIndex === 1"
      class="p-xl"
    >
      <h2>Step 2 Content</h2>
      <p> or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words et</p>
    </div>
    <div
      v-if="currentStepIndex === 2"
      class="p-xl"
    >
      <h2>Step 3 Content</h2>
      <p> vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id qu</p>
    </div>
  </div>
</template>

<script>
// @ts-check
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import { TitledProgressStepper } from '@/components/library/progressSteppers/TitledProgressStepper';
import BarProgressStepper from '@/components/library/progressSteppers/BarProgressStepper/BarProgressStepper.vue';


export default {
  components: {
    BaseButton,
    TitledProgressStepper,
    BarProgressStepper,
  },
  data() {
    return {
      steps: [
        {
          title: 'Collect Underpants', current: true, disabled: false, clickable: true,
        },
        {
          title: '???', current: false, disabled: true, clickable: true,
        },
        {
          title: 'Profit', current: false, disabled: true, clickable: true,
        },
      ],
    };
  },
  computed: {
    currentStep() {
      return this.steps.find(step => step.current);
    },
    currentStepIndex() {
      return this.steps.indexOf(this.currentStep);
    },
  },
  methods: {
    /**
     * @param {number} destinationStepIndex
     */
    goToStep(destinationStepIndex) {
      // complete current step
      this.steps[this.currentStepIndex].current = false;
      // set new current step
      // if we're on final step go back to beginning
      if (destinationStepIndex > this.steps.length - 1) {
        this.steps[0].current = true;
        this.steps.forEach((step, index) => {
          if (index > 0) {
            this.steps[index].disabled = true;
          }
        });
      } else { // just go to selected step
        this.steps[destinationStepIndex].current = true;
        this.steps[destinationStepIndex].disabled = false;
      }
    },
  },
};
</script>
